<div class="attachment-lightbox-trigger" [aionzLightbox]="lightboxItems()">
  <div
    class="attachment-card"
    [aionzLightbox]="0"
    [attr.aria-label]="actionLabel()">
    <div class="attachment-file-icon">
      @if (isImageAttachment(attachment())) {
        <mat-icon color="primary">image</mat-icon>
      } @else {
        <mat-icon>description</mat-icon>
      }
    </div>

    <div class="attachment-info">
      <strong
        class="attachment-name"
        [aionzTooltip]="attachment().fileName"
        mode="message">
        {{ attachment().fileName }}
      </strong>
      <span class="attachment-meta">
        {{ attachment().uploadedAt | date: 'dd MMM, HH:mm' }} ·
        {{ attachment().fileType }}
        @if (attachment().sizeLabel) {
          · {{ attachment().sizeLabel }}
        }
      </span>
    </div>

    <button
      mat-icon-button
      type="button"
      class="attachment-download-button"
      [attr.aria-label]="downloadLabel()"
      (click)="onDownloadClick($event, attachment())">
      <mat-icon>download</mat-icon>
    </button>
  </div>
</div>